export const skill_MERN = [
  {
    id: 1,
    skill: "MongoDB",
    icon: "fa fa-database fa-2x yellow-text",
  },
  {
    id: 2,
    skill: "Express",
    icon: "fas fa-server fa-2x orange-text",
  },
  {
    id: 3,
    skill: "REST API",
    icon: "fas fa-paper-plane fa-2x red-text",
  },
  {
    id: 4,
    skill: "NodeJs",
    icon: "fab fa-node fa-2x green-text",
  },
];

export const skill_others = [
  {
    id: 0,
    skill: "React (hook)",
    icon: "fab fa-2x fa-react",
  },
  {
    id: 10,
    skill: "VueJs",
    icon: "fab fa-vuejs fa-2x green-text",
  },
  {
    id: 2,
    skill: "JavaScript (ES6)",
    icon: "fab fa-js-square fa-2x yellow-text",
  },

  {
    id: 14,
    skill: "Type-Script",
    icon: "fab fa-js fa-2x blue-text",
  },
  {
    id: 15,
    skill: "Unit-Test (JEST)",
    icon: "fas fa-wrench fa-2x orange-text",
  },
  {
    id: 14,
    skill: "Styled-Component",
    icon: "fas fa-brush fa-2x pink-text",
  },
  {
    id: 5,
    skill: "Redux",
    icon: "fas fa-store-alt fa-2x purple-text",
  },

  {
    id: 11,
    skill: "And-Design",
    icon: "fas fa-bug fa-2x red-text",
  },
  {
    id: 13,
    skill: "Element-UI",
    icon: "fab fa-uikit fa-2x yellow-text",
  },
  {
    id: 12,
    skill: "Bootstrap5",
    icon: "fab fa-bootstrap fa-2x purple-text",
  },
  {
    id: 7,
    skill: "JWT",
    icon: "fas fa-coins fa-2x orange-text",
  },

  {
    id: 8,
    skill: "Async/Await",
    icon: "far fa-handshake fa-2x green-text",
  },

  {
    id: 9,
    skill: "JSX",
    icon: "fab fa-react fa-2x blue-text",
  },
  {
    id: 1,
    skill: "HTML5",
    icon: "fab fa-html5 fa-2x",
  },
  {
    id: 4,
    skill: "CSS",
    icon: "fab fa-css3-alt fa-2x red-text",
  },
];
